import { ImgHTMLAttributes } from 'react'
import { MediaMatchName, ViewportDefinition, ViewportMatchName } from 'interfaces/viewport'
import { Document } from 'interfaces/DOM'
import * as range from 'lodash/range'

declare const document: Document

type BaseMediaConfig = {
  mediaQueries: Record<MediaMatchName, string>
}
type RawMediaConfig = BaseMediaConfig & {
  viewportDefinitions: ViewportDefinition[]
}
type MediaConfig = BaseMediaConfig & {
  viewportMap: Map<ViewportDefinition['name'], ViewportDefinition>
}

declare const __MEDIA_CONFIG__: RawMediaConfig

const viewportMap: Map<ViewportDefinition['name'], ViewportDefinition> = new Map()
const rawMediaConfig = __MEDIA_CONFIG__
rawMediaConfig.viewportDefinitions.forEach((def) => {
  viewportMap.set(def.name, def)
})

export const MEDIA_CONFIG: MediaConfig = {
  mediaQueries: rawMediaConfig.mediaQueries,
  viewportMap,
}

const getMediaQuery = (queryName: MediaMatchName) =>
  MEDIA_CONFIG.mediaQueries[queryName]


type ViewportCompareOperation = '<' | '<=' | '>' | '>=' | '=='
type OperationMap = Record<ViewportCompareOperation, (a: number, b: number) => boolean>
// it's safer to define the operations in this way rather than eval them
const OPERATION_MAP: OperationMap = {
  '<': (a: number, b: number) => a < b,
  '<=': (a: number, b: number) => a <= b,
  '==': (a: number, b: number) => a === b,
  '>': (a: number, b: number) => a > b,
  '>=': (a: number, b: number) => a >= b,
}
export const compareViewports = (currentViewportName: ViewportMatchName | null, operation: ViewportCompareOperation, targetViewportName: ViewportMatchName | null): boolean => {
  if (!currentViewportName || !targetViewportName) {
    return false
  }

  const currentViewport = viewportMap.get(currentViewportName)
  const targetViewport = viewportMap.get(targetViewportName)
  const operationFunction = OPERATION_MAP[operation]

  if (!currentViewport || !targetViewport || !operationFunction) {
    return false
  }

  return operationFunction(currentViewport.value, targetViewport.value)
}

export const isMobileViewport = () => window.matchMedia(getMediaQuery('mobile')).matches

export const IS_IE = window.matchMedia(getMediaQuery('IE-only')).matches

export const getFullscreenElement = () => {
  return null
    || document.fullscreenElement
    || document.webkitFullscreenElement
    || document.mozFullScreenElement
    || document.msFullscreenElement
}

const MAX_SUPPORTED_DENSITY = 3
export function createResponsiveImgProps (filePath: string): Pick<ImgHTMLAttributes<HTMLImageElement>, 'srcSet' & 'src'> {
  const dotSplit = filePath.split('.')
  const ext = dotSplit.slice(-1)
  const filePathWoExt = dotSplit.slice(0, -1)

  return {
    src: `${ filePathWoExt }.${ ext }`,
    srcSet: range(2, MAX_SUPPORTED_DENSITY)
      .map((density) => `${ filePathWoExt }@${ density }x.${ ext } ${ density }x`)
      .join(', '),
  }
}
